export enum EthereumAssetMainnetShortcode {
  ChainlinkEthToken = 'LINK_ERC20',
  DaiEthToken = 'DAI_ERC20',
  TetherEthToken = 'USDT_ERC20',
  UniswapEthToken = 'UNI_ERC20',
  USDCoinEthToken = 'USDC_ERC20',
  ApeCoinEthToken = 'APE_ERC20',
  AaveEthToken = 'AAVE_ERC20',
  BNBEthToken = 'BNB_ERC20',
  TerraClassicEthToken = 'LUNC_ERC20',
  BasicAttentionEthToken = 'BAT_ERC20',
  EuroStableEthToken = 'EURST_ERC20',
  PolygonEthToken = 'MATIC_ERC20',
  BankorEthToken = 'BNT_ERC20',
  WallexEthToken = 'WLXT_ERC20',
  USDDEthToken = 'USDD_ERC20',
  GeminiDollarEthToken = 'GUSD_ERC20',
  FeiUSDEthToken = 'FEI_ERC20',
  PAXDollarEthToken = 'USDP_ERC20',
  TrueUSDEthToken = 'TUSD_ERC20',
  TheGraphEthToken = 'GRT_ERC20',
  PAXOSGOLDEthToken = 'PAXG_ERC20',
  AugurEthToken = 'REP_ERC20',
  BalancerEthToken = 'BAL_ERC20',
  CompoundEthToken = 'COMP_ERC20',
  GnosisEthToken = 'GNO_ERC20',
  KavaEthToken = 'KAVA_ERC20',
  KyberNetworkCrystalV2EthToken = 'KNC_ERC20',
  MelonEthToken = 'MLN_ERC20',
  SynthetixEthToken = 'SNX_ERC20',
  OrchidEthToken = 'OXT_ERC20',
  StorjEthToken = 'STORJ_ERC20',
  YearnfinanceEthToken = 'YFI_ERC20',
  EnjinCoinEthToken = 'ENJ_ERC20',
  FLOWEthToken = 'FLOW_ERC20',
  DecentralandEthToken = 'MANA_ERC20',
  AnkrEthToken = 'ANKR_ERC20',
  AragonEthToken = 'ANT_ERC20',
  AavegotchiEthToken = 'GHST_ERC20',
  KeepNetworkEthToken = 'KEEP_ERC20',
  LivepeerEthToken = 'LPT_ERC20',
  MakerEthToken = 'MKR_ERC20',
  OceanProtocolEthToken = 'OCEAN_ERC20',
  RaribleEthToken = 'RARI_ERC20',
  RenEthToken = 'REN_ERC20',
  TheSandboxEthToken = 'SAND_ERC20',
  SerumEthToken = 'SRM_ERC20',
  SushiSwapEthToken = 'SUSHI_ERC20',
  TBTCEthToken = 'TBTC_ERC20',
  ZeroXProtocolEthToken = 'ZRX_ERC20',
  NYMEthToken = 'NYM_ERC20',
  OneInchNetworkEthToken = '1INCH_ERC20',
  AlchemyPayEthToken = 'ACH_ERC20',
  AmbireAdExEthToken = 'ADX_ERC20',
  AdventureGoldEthToken = 'AGLD_ERC20',
  AlchemixEthToken = 'ALCX_ERC20',
  MyNeighborAliceEthToken = 'ALICE_ERC20',
  API3EthToken = 'API3_ERC20',
  ARPAEthToken = 'ARPA_ERC20',
  StarAtlasEthToken = 'ATLAS_ERC20',
  AudiusEthToken = 'AUDIO_ERC20',
  AxieInfinityEthToken = 'AXS_ERC20',
  BadgerDAOEthToken = 'BADGER_ERC20',
  BandProtocolEthToken = 'BAND_ERC20',
  BiconomyEthToken = 'BICO_ERC20',
  BitDAOEthToken = 'BIT_ERC20',
  BluzelleEthToken = 'BLZ_ERC20',
  BobaNetworkEthToken = 'BOBA_ERC20',
  BarnBridgeEthToken = 'BOND_ERC20',
  Coin98EthToken = 'C98_ERC20',
  CelerNetworkEthToken = 'CELR_ERC20',
  ChromiaEthToken = 'CHR_ERC20',
  ChilizEthToken = 'CHZ_ERC20',
  COTIEthToken = 'COTI_ERC20',
  CovalentEthToken = 'CQT_ERC20',
  CrustShadowEthToken = 'CSM_ERC20',
  CartesiEthToken = 'CTSI_ERC20',
  CivicEthToken = 'CVC_ERC20',
  ConvexFinanceEthToken = 'CVX_ERC20',
  DentEthToken = 'DENT_ERC20',
  DYdXEthToken = 'DYDX_ERC20',
  EthereumNameServiceEthToken = 'ENS_ERC20',
  HarvestFinanceEthToken = 'FARM_ERC20',
  FetchaiEthToken = 'FET_ERC20',
  AmpleforthGovernanceEthToken = 'FORTH_ERC20',
  StaFiEthToken = 'FIS_ERC20',
  FantomEthToken = 'FTM_ERC20',
  FraxShareEthToken = 'FXS_ERC20',
  GalxeEthToken = 'GAL_ERC20',
  GitcoinEthToken = 'GTC_ERC20',
  HashflowEthToken = 'HFT_ERC20',
  IDEXEthToken = 'IDEX_ERC20',
  ImmutableEthToken = 'IMX_ERC20',
  InjectiveEthToken = 'INJ_ERC20',
  JasmyCoinEthToken = 'JASMY_ERC20',
  SelfKeyEthToken = 'KEY_ERC20',
  LCXEthToken = 'LCX_ERC20',
  LidoDAOEthToken = 'LDO_ERC20',
  LoopringEthToken = 'LRC_ERC20',
  MaskNetworkEthToken = 'MASK_ERC20',
  MirrorProtocolEthToken = 'MIR_ERC20',
  MarinadeStakedSOLEthToken = 'MSOL_ERC20',
  MultichainEthToken = 'MULTI_ERC20',
  GensoKishiMetaverseEthToken = 'MV_ERC20',
  MXCEthToken = 'MXC_ERC20',
  NumeraireEthToken = 'NMR_ERC20',
  OriginProtocolEthToken = 'OGN_ERC20',
  OxygenEthToken = 'OXY_ERC20',
  ParalinkNetworkEthToken = 'PARA_ERC20',
  PerpetualProtocolEthToken = 'PERP_ERC20',
  PhalaNetworkEthToken = 'PHA_ERC20',
  PlayDappEthToken = 'PLA_ERC20',
  PolkastarterEthToken = 'POLS_ERC20',
  MarlinEthToken = 'POND_ERC20',
  PowerledgerEthToken = 'POWR_ERC20',
  PSTAKEFinanceEthToken = 'PSTAKE_ERC20',
  QuantEthToken = 'QNT_ERC20',
  RadicleEthToken = 'RAD_ERC20',
  SuperRareEthToken = 'RARE_ERC20',
  RaydiumEthToken = 'RAY_ERC20',
  RubicEthToken = 'RBC_ERC20',
  RequestEthToken = 'REQ_ERC20',
  XecRLCEthToken = 'RLC_ERC20',
  RenderEthToken = 'RNDR_ERC20',
  RookEthToken = 'ROOK_ERC20',
  RocketPoolEthToken = 'RPL_ERC20',
  SpellEthToken = 'SPELL_ERC20',
  StargateFinanceEthToken = 'STG_ERC20',
  SuperVerseEthToken = 'SUPER_ERC20',
  SynapseEthToken = 'SYN_ERC20',
  TEthToken = 'T_ERC20',
  AlienWorldsEthToken = 'TLM_ERC20',
  TokemakEthToken = 'TOKE_ERC20',
  TribeEthToken = 'TRIBE_ERC20',
  TrueFiEthToken = 'TRU_ERC20',
  VirtuaEthToken = 'TVK_ERC20',
  UMAEthToken = 'UMA_ERC20',
  WOONetworkEthToken = 'WOO_ERC20',
  OnyxcoinEthToken = 'XCN_ERC20',
  RobonomicsnetworkEthToken = 'XRT_ERC20',
  YGGYieldGuildGamesEthToken = 'YGG_ERC20',
  HEXEthToken = 'HEX_ERC20',
  UNUSSEDLEOEthToken = 'LEO_ERC20',
  ToncoinEthToken = 'TON_ERC20',
  CronosEthToken = 'CRO_ERC20',
  OKBEthToken = 'OKB_ERC20',
  FraxEthToken = 'FRAX_ERC20',
  HuobiEthToken = 'HT_ERC20',
  MinesOfDalarniaEthToken = 'DAR_ERC20',
  AIOZNetworkEthToken = 'AIOZ_ERC20',
  VerasityEthToken = 'VRA_ERC20',
  EfinityEthToken = 'EFI_ERC20',
  TheParadoxMetaverseEthToken = 'PARADOX_ERC20',
  QredoEthToken = 'QRDO_ERC20',
  ArchieNekoEthToken = 'ARCHIE_ERC20',
  KuCoinEthToken = 'KCS_ERC20',
  KlaytnEthToken = 'KLAY_ERC20',
  NEOEthToken = 'NEO_ERC20',
  TetherGoldEthToken = 'XAUT_ERC20',
  OsmosisEthToken = 'OSMO_ERC20',
  WENWENUSDNEthToken = 'USDN_ERC20',
  SweatEconomyEthToken = 'SWEAT_ERC20',
  WrappedBitcoinEthToken = 'WBTC_ERC20',
  BUSDEthToken = 'BUSD_ERC20',
  CurveDAOEthToken = 'CRV_ERC20',
  ShibaInuEthToken = 'SHIB_ERC20',
}

export enum EthereumAssetSepoliaShortcode {
  ChainlinkEthTokenSepolia = 'LINK_ERC20_SEP',
  DaiEthTokenSepolia = 'DAI_ERC20_SEP',
  TetherEthTokenSepolia = 'USDT_ERC20_SEP',
  UniswapEthTokenSepolia = 'UNI_ERC20_SEP',
  USDCoinEthTokenSepolia = 'USDC_ERC20_SEP',
  ApeCoinEthTokenSepolia = 'APE_ERC20_SEP',
  AaveEthTokenSepolia = 'AAVE_ERC20_SEP',
  GeminiDollarEthTokenSepolia = 'GUSD_ERC20_SEP',
  FeiUSDEthTokenSepolia = 'FEI_ERC20_SEP',
  PAXDollarEthTokenSepolia = 'USDP_ERC20_SEP',
  TrueUSDEthTokenSepolia = 'TUSD_ERC20_SEP',
  PAXOSGOLDEthTokenSepolia = 'PAXG_ERC20_SEP',
  AugurEthTokenSepolia = 'REP_ERC20_SEP',
  BalancerEthTokenSepolia = 'BAL_ERC20_SEP',
  CompoundEthTokenSepolia = 'COMP_ERC20_SEP',
  GnosisEthTokenSepolia = 'GNO_ERC20_SEP',
  KyberNetworkCrystalV2EthTokenSepolia = 'KNC_ERC20_SEP',
  MelonEthTokenSepolia = 'MLN_ERC20_SEP',
  SynthetixEthTokenSepolia = 'SNX_ERC20_SEP',
  OrchidEthTokenSepolia = 'OXT_ERC20_SEP',
  StorjEthTokenSepolia = 'STORJ_ERC20_SEP',
  EnjinCoinEthTokenSepolia = 'ENJ_ERC20_SEP',
  DecentralandEthTokenSepolia = 'MANA_ERC20_SEP',
  MakerEthTokenSepolia = 'MKR_ERC20_SEP',
  RaribleEthTokenSepolia = 'RARI_ERC20_SEP',
  TheSandboxEthTokenSepolia = 'SAND_ERC20_SEP',
  SerumEthTokenSepolia = 'SRM_ERC20_SEP',
  TBTCEthTokenSepolia = 'TBTC_ERC20_SEP',
  ZeroXProtocolEthTokenSepolia = 'ZRX_ERC20_SEP',
  MyNeighborAliceEthTokenSepolia = 'ALICE_ERC20_SEP',
  ARPAEthTokenSepolia = 'ARPA_ERC20_SEP',
  AxieInfinityEthTokenSepolia = 'AXS_ERC20_SEP',
  BitDAOEthTokenSepolia = 'BIT_ERC20_SEP',
  Coin98EthTokenSepolia = 'C98_ERC20_SEP',
  DYdXEthTokenSepolia = 'DYDX_ERC20_SEP',
  EthereumNameServiceEthTokenSepolia = 'ENS_ERC20_SEP',
  StaFiEthTokenSepolia = 'FIS_ERC20_SEP',
  GitcoinEthTokenSepolia = 'GTC_ERC20_SEP',
  HashflowEthTokenSepolia = 'HFT_ERC20_SEP',
  MXCEthTokenSepolia = 'MXC_ERC20_SEP',
  QuantEthTokenSepolia = 'QNT_ERC20_SEP',
  RenderEthTokenSepolia = 'RNDR_ERC20_SEP',
  RookEthTokenSepolia = 'ROOK_ERC20_SEP',
  WrappedBitcoinEthTokenSepolia = 'WBTC_ERC20_SEP',
  TokemakEthTokenSepolia = 'TOKE_ERC20_SEP',
  BUSDEthTokenSepolia = 'BUSD_ERC20_SEP',
  OKBEthTokenSepolia = 'OKB_ERC20_SEP',
}

export const EthereumAssetShortcode = Object.assign({}, EthereumAssetMainnetShortcode, EthereumAssetSepoliaShortcode);
export type EthereumAssetShortcode = EthereumAssetMainnetShortcode | EthereumAssetSepoliaShortcode;

export const ETHEREUM_TOKENS = new Set(Object.values(EthereumAssetShortcode));
